

import { Link as LinkReact } from 'react-router-dom';



interface MenuBottomLinkProps {
    link: string;
    title: string;
    icon?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
    [key: string]: any;
}

export const MenuBottomLink: React.FC<MenuBottomLinkProps> = ({
    link,
    title,
    icon = null,
    className = '',
    children,
    ...props
}) => {
    return (
        <LinkReact to={link} className={className}>
            <div className="button-menu-body">
                {icon}
                <p>{title}</p>
            </div>
            {props.children}
        </LinkReact>
    );
};